const renewableMmeguruTab = (() => {
  if (document.querySelector("body#pageRenewableenergy.meguru") !== null) {



    let sW = window.innerWidth;

    const secMeguro = document.querySelector('#jsSecMeguro');

    const tabWraps = secMeguro.querySelectorAll('.js-tab-wrap');


    tabWraps.forEach((element0, index0) => {

      const btns = element0.querySelectorAll('.js-btn-box');
      const cntnts = element0.querySelectorAll('.js-cntnt-area');

      btns.forEach((element, index) => {
        element.addEventListener('click', () => {
          for (let i = 0; i < btns.length; i++) {
            btns[i].classList.remove('is-act');
            cntnts[i].classList.remove('is-act');
            cntnts[i].classList.remove('is-act2');
          }
          btns[index].classList.add('is-act');
          cntnts[index].classList.add('is-act');
          setTimeout(() => {
            cntnts[index].classList.add('is-act2');
          }, 100);
        });
      });

      btns[0].classList.add('is-act');
      cntnts[0].classList.add('is-act');
      cntnts[0].classList.add('is-act2');

    });





  }
})()
export default renewableMmeguruTab;